$(document).ready(function() {

	$('.navbar-toggle').on('click', function() {
		$('body').toggleClass('menu-is-open');
	});	

});